// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Diseases_wrapper__3iZzZ","empty_wrapper":"Diseases_empty_wrapper__nD6vA"};